import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';

/**
 * Only appears once there is something to see — an always-present empty cart
 * is chrome nobody needs in a conversational marketplace.
 */
export function CartButton() {
  const {
    count,
    setOpen
  } = useCart();
  return <AnimatePresence data-id="element-904" data-mp="2f4sun90ebzpp">
      {count > 0 && <motion.button initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.18,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={() => setOpen(true)} aria-label={`Your order — ${count} item${count === 1 ? '' : 's'}`} className="relative flex items-center gap-2 pl-3 pr-3.5 py-2 rounded-full bg-dark-navy text-white text-[13px] font-bold shadow-medium hover:bg-slate-800 transition-colors duration-150 ease-out" data-id="element-905" data-mp="2f63vp12gitd4">
          <ShoppingBagIcon className="w-4 h-4" data-id="element-906" data-mp="o8ckrsnu3oyw" />
          <span data-id="element-907" data-mp="jgumjcd742hm">Order</span>
          <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-white/20 flex items-center justify-center text-[11px]" data-id="element-908" data-mp="jg1apwzdqmsm">
            {count}
          </span>
        </motion.button>}
    </AnimatePresence>;
}